import { render, staticRenderFns } from "./TeacherDashboard.vue?vue&type=template&id=3cc3d894&scoped=true&"
import script from "./TeacherDashboard.vue?vue&type=script&lang=js&"
export * from "./TeacherDashboard.vue?vue&type=script&lang=js&"
import style0 from "./TeacherDashboard.vue?vue&type=style&index=0&id=3cc3d894&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc3d894",
  null
  
)

export default component.exports